/*SYSTEM IMPORTS*/
import React from 'react'
import c from 'classnames'

import Ratio from 'components/Ratio'
// import IconsImage from 'images/icons.svg'

import './style'
import './media'

/*CORES*/
import AppCore from 'cores/AppCore'

const Clinic = props => (
    <div className={c("clinic", props.className)}>
        <div className="clinic-wrapp">
            <h2>
                { AppCore.Interfaces.t( "DoctorLanding.Ui.Clinic.Index.Title" ) }
            </h2>
            { props.isset_preview && <div className="clinic-photo">
                <Ratio value={1.67}>
                    {props.image}
                </Ratio>
            </div> }
            <div className="clinic-name">
                {props.name}
            </div>
            <div className="clinic-info">
                {props.children}
            </div>
        </div>
    </div>
) 

export default Clinic
